<accordion-group heading="Archivos adjuntos" [isOpen]="true" *ngIf="useAccordion">
  <div class="row form-group" *ngFor="let file of filesList; index as idx;">
    <label class="col-sm-3 col-md-2 col-form-label" [for]="'attachment' + idx">
      <b>{{ file.title }}</b>
      <span class="text-danger" *ngIf="file.isRequired">*</span>
    </label>
    <div class="col-sm-8 col-md-4">
      <input type="file" [id]="'attachment' + idx" (change)="onFileChange($event, idx)">
      <label class="custom-file-label mb-2" [for]="'attachment' + idx">{{ file.file ? file.file.name : 'Elija el archivo' }}</label>
    </div>
    <div class="col-sm-1 col-md-2" *ngIf="!!file.file">
      <i class="fa fa-eye font-3xl mt-1 text-primary pointer" (click)="viewDocument(file.file)"></i>
    </div>
  </div>
  <p class="text-danger">* Archivos obligatorios</p>
</accordion-group>


<div *ngIf="!useAccordion">
  <div class="row form-group" *ngFor="let file of filesList; index as idx;">
    <label class="col-sm-3 col-md-2 col-form-label" [for]="'attachment' + idx">
      <b>{{ file.title }}</b>
      <span class="text-danger" *ngIf="file.isRequired">*</span>
    </label>
    <div class="col-sm-8 col-md-4">
      <input type="file" [id]="'attachment' + idx" (change)="onFileChange($event, idx)">
      <label class="custom-file-label mb-2" [for]="'attachment' + idx">{{ file.file ? file.file.name : 'Elija el archivo' }}</label>
    </div>
    <div class="col-sm-1 col-md-2" *ngIf="!!file.file">
      <i class="fa fa-eye font-3xl mt-1 text-primary pointer" (click)="viewDocument(file.file)"></i>
    </div>
  </div>
  <p class="text-danger">* Archivos obligatorios</p>
</div>
